<script>
import axios from '@/utils/axios';
import { Modal } from 'bootstrap';
import { useToast } from 'vue-toastification';
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
export default {
inject: ['setLoading'],  
  data() {
    return {
      editor: ClassicEditor,
      errors: {}, 
      toast: useToast(),
      id: '',
      customer_id: '',
      description: '',
    };
  },
  methods: {
   
   addCustomerNote(customer){
    this.customer_id = customer.id; 
   },
   
   editCustomerNote(customer, note){
    this.id = note.id;
    this.description = note.description;
    this.customer_id = customer.id; 
   },

   async submitCustomerNoteForm() {
     this.errors = {};
     this.setLoading(true);
     try{
      if(this.id){
       const response = await axios.put(`customers/${this.customer_id}/comments/update`, {
        id: this.id,
        description: this.description  
       });
       this.toast.success(response.data.message);
      }else{
       const response = await axios.post(`customers/${this.customer_id}/comments/create`, {
        description: this.description  
       });
       this.toast.success(response.data.message);
      }
      
      this.$emit('updated'); 
      this.closeModal('customer_notes_modal');
      this.resetForm();
     }catch(error){
      if(error.type === 'validation'){
       this.errors = error.errors;
      }else{
       this.toast.error(error.message); 
      }
     }finally{
      this.setLoading(false);
     } 
    },

  async deleteCustomerNote(){
   this.errors = {};
   this.setLoading(true); 
   try{
    const response = await axios.delete(`customers/${this.customer_id}/comments/${this.id}/delete`);
    this.toast.success(response.data.message);
    this.$emit('updated');
    this.closeModal('customer_note_delete_modal');
   }catch(error){
    if(error.type == 'validation'){
     this.errors = error.errors;
    }else{
     this.toast.error(error.message); 
    }
   }finally{
    this.setLoading(false);
   }
  },

  closeModal(modalId) {
   const modalEl = document.getElementById(modalId);
   const modal = Modal.getInstance(modalEl);
   if (modal) modal.hide();
  },

  resetForm() {
   this.id = null;
   this.description = '';
   this.errors = {};
  },

  },
};
</script>

<template>
<!-- Add Note -->
<div class="modal fade" id="customer_notes_modal">
<div class="modal-dialog modal-dialog-centered">
<div class="modal-content">
<div class="modal-header">
<h4 class="modal-title">Add Notes</h4>
<button type="button" class="btn-close custom-btn-close" data-bs-dismiss="modal" aria-label="Close">
  <i class="ti ti-x"></i>
</button>
</div>
<form @submit.prevent="submitCustomerNoteForm">
<div class="modal-body">
  <div class="row">
    <div class="col-lg-12">
      <div class="mb-0 summer-description-box notes-summernote">
        <label class="form-label">Descriptions</label>
        <ckeditor :editor="editor" v-model="description"></ckeditor>
        <div v-if="errors.description" class="text-danger small mt-1">{{ errors.description[0] }}</div>
        <small>Maximum 255 Characters</small>
      </div>
    </div>
  </div>
</div>
  <div class="modal-footer">
    <button type="button" class="btn btn-light me-2" data-bs-dismiss="modal"> Cancel </button>
    <button type="submit" class="btn btn-primary">Submit</button>
  </div>
  </form>
</div>
</div>
</div>
  <!-- /Add Note -->

  
  <!-- Delete Modal -->
  <div class="modal fade" id="customer_note_delete_modal">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-body text-center">
          <span class="avatar avatar-xl bg-transparent-danger text-danger mb-3">
            <i class="ti ti-trash-x fs-36"></i>
          </span>
          <h4 class="mb-1">Confirm Delete</h4>
          <p class="mb-3">
            You want to delete all the marked items, this cant be undone once you delete.
          </p>
          <div class="d-flex justify-content-center">
            <a href="javascript:void(0);" class="btn btn-light me-3" data-bs-dismiss="modal">Cancel</a>
            <a href="javascript:void(0);" class="btn btn-danger" @click="deleteCustomerNote">Yes, Delete</a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Delete Modal -->

 
</template>

